declare global {
  interface Window {
    /** Injected by react-native-webview. Used to send messages to the native app. */
    ReactNativeWebView?: {
      postMessage(msg: string): void;
    };
  }
}

type NativeMessage = { type: 'close' } | { type: 'scanQrCode' };

/**
 * Sends a structured message from the web-app (running in a WebView) to the
 * native mobile app. The native side handles these messages via the WebView's
 * `onMessage` prop.
 *
 * Supported messages:
 * - `{ type: 'close' }` — tells the native app to dismiss the action sheet.
 * - `{ type: 'scanQrCode' }` — asks the native app to open the QR scanner.
 */
export function postMessageToNative(message: NativeMessage) {
  window.ReactNativeWebView?.postMessage(JSON.stringify(message));
}
